import type { RouteObject } from "react-router-dom";
import OrdersList, { ordersListLoader } from "./List";
import OrderDetailPage, { orderDetailLoader } from "./Detail";
import CompleteStepsPage, { completeStepsLoader } from "./Complete";
import DeliveryZonesPage, { deliveryZonesLoader } from "./DeliveryZones";
import OrderSettingsPage, { orderSettingsLoader } from "./Settings";
import AppError from "../app-error";

/** Nested under the root route's children — inherits the permission guard and AppShell. */
export const ordersRoutes: RouteObject[] = [
  { path: "orders", Component: OrdersList, loader: ordersListLoader, errorElement: <AppError /> },
  { path: "orders/delivery-zones", Component: DeliveryZonesPage, loader: deliveryZonesLoader, errorElement: <AppError /> },
  { path: "orders/settings", Component: OrderSettingsPage, loader: orderSettingsLoader, errorElement: <AppError /> },
  { path: "orders/:orderNumber", Component: OrderDetailPage, loader: orderDetailLoader, errorElement: <AppError /> },
  { path: "orders/:orderNumber/complete", Component: CompleteStepsPage, loader: completeStepsLoader, errorElement: <AppError /> },
];
